import variables from 'common/config/variables';
import { TestableComponent } from 'common/interfaces';
import { isEmpty } from 'lodash';
import React from 'react';
import './Image.styles';

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement>, TestableComponent {
  lazy?: boolean;
  fallbackSrc?: string;
  transition?: 'none' | 'fade';
  visible?: boolean;
}
const Image: React.FC<ImageProps> = ({ lazy, fallbackSrc, testId, className, src, ...rest }) => {
  const onError = React.useCallback(
    (e: React.SyntheticEvent<HTMLImageElement>) => {
      const defaultSrc = fallbackSrc || variables.DEFAULT_LOGO_PATH;
      const img = e.currentTarget;
      if (img.src === defaultSrc) {
        e.preventDefault();
        return;
      }
      img.onerror = null;
      img.src = defaultSrc;
    },
    [fallbackSrc]
  );

  return (
    <img
      onError={onError}
      loading={lazy ? 'lazy' : undefined}
      decoding="async"
      data-test-id={testId}
      className={`${isEmpty(className) ? '' : className} image`}
      src={src}
      {...rest}
    />
  );
};

export default React.memo(Image);
